var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"pull-left btn btn-sm btn-primary show-button",on:{"click":_vm.switchButton}},[_vm._v("\n  "+_vm._s(_vm.getButtonText)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }